import { queryOptions } from '@tanstack/react-query';

import type {
  BookingEventDetail,
  BookingEventQueryParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingEventKeys = {
  all: () => ['bookingEvents'] as const,
  detail: (props: BookingEventQueryParams) =>
    [...bookingEventKeys.all(), 'detail', props.url, props.id] as const,
};

export const bookingEventQueries = {
  detail: (props: BookingEventQueryParams) =>
    queryOptions({
      queryKey: bookingEventKeys.detail(props),
      queryFn: () =>
        HttpClient.request<BookingEventDetail>({
          method: 'GET',
          url: `${props.url}/${props.id}`,
        }),
      enabled: !!props.url && !!props.id,
      refetchOnWindowFocus: true,
    }),
};
